import api from './api';

// Webhook yönetimi — iç yönetim uçları (backend WebhookEndpointController
// [Route("v1/webhook-endpoints")] + WebhookDeliveryController [Route("v1/webhook-deliveries")];
// sınıf düzeyinde PA.Read + RequireActiveModule("PA"), mutasyonlar PA.Write).
// Public API tasarım belgesi §6.5: yönetim PM ayarlarından Entegrasyonlar'a taşındı.
//
// Yanıt tipleri (camelCase, backend Dtos/WebhookDtos.cs ile birebir):
//   WebhookEndpointResponse  { id, name, url, secretMask, eventKeys[], isEnabled, autoDisabledAt,
//                              previousSecretExpiresAt, lastDeliveryAt, lastStatus, dlqCount,
//                              succeeded24h, failed24h, successRate24h, createDate, updateDate }
//   WebhookEndpointCreatedResponse  WebhookEndpointResponse + plainSecret — düz sır YALNIZ
//                              oluşturma / sır yenileme yanıtında bir kez gelir.
//   WebhookEventKeyOption    { eventKey, label, moduleCode }
//   WebhookDeliveryResponse  { id, eventKey, status, attemptCount, lastError, responseStatus,
//                              enqueuedAt, processedAt, dlqAt, nextAttemptAt, canReplay }
//   WebhookTestResult        { status, responseStatus, error }

export const getWebhookEndpoints = () => api.get('/v1/webhook-endpoints');

// Kiracının abone olduğu modüllerin webhook'a seçilebilir olayları.
export const getWebhookEventKeys = () => api.get('/v1/webhook-endpoints/event-keys');

// Gövde: { name, url, eventKeys: [], isEnabled } — sır GÖNDERİLMEZ, sunucu üretir.
export const createWebhookEndpoint = (payload) => api.post('/v1/webhook-endpoints', payload);

// TAM DEĞİŞTİRİR; sırrı değiştirmez.
export const updateWebhookEndpoint = (id, payload) => api.put(`/v1/webhook-endpoints/${id}`, payload);

export const deleteWebhookEndpoint = (id) => api.delete(`/v1/webhook-endpoints/${id}`);

// Senkron test gönderimi. Hedefin 4xx/5xx'i iç hata DEĞİLDİR (200 + data.status=false);
// yalnız hedefe hiç ulaşılamazsa / sır çözülemezse 500 `webhook.testFailed` — o sonucu
// sekme kendi satır-içi kutusunda gösterir, interceptor'ın genel toast'ı bastırılır.
export const testWebhookEndpoint = (id) => api.post(`/v1/webhook-endpoints/${id}/test`, {}, {
  skipErrorToast: ['webhook.testFailed'],
});

// Yeni sır üretir (yanıtta bir kez); eski sır 24 saat ikinci imzada geçerli kalır.
export const rotateWebhookSecret = (id) => api.post(`/v1/webhook-endpoints/${id}/rotate-secret`);

// Teslimat günlüğü — sayfalı (1 tabanlı), durum: all | pending | failed | success | dlq.
export const getWebhookDeliveries = (id, { page = 1, pageSize = 20, status } = {}) => api.get(
  `/v1/webhook-endpoints/${id}/deliveries`,
  { params: { page, pageSize, ...(status ? { status } : {}) } },
);

// Yalnız kalıcı başarısız (DLQ) teslimat yeniden kuyruğa alınır.
export const replayWebhookDelivery = (deliveryId) => api.post(`/v1/webhook-deliveries/${deliveryId}/replay`);
